const animationTimers = new WeakMap();
const slideEasing = 'ease-in-out';

const openChatButton = document.getElementById('open-chat');
if (openChatButton) {
    openChatButton.addEventListener('click', (e) => {
        e.preventDefault();
        const actualChatButton = document.getElementById('dx_chatbot_fab_id');
        if (actualChatButton) {
            actualChatButton.click();
        }
    });
}

const sections = document.querySelectorAll('section.element');

sections.forEach((el, i) => {
    if (i === 0) {
        el.classList.add('first');
    }
    if (i === sections.length - 1) {
        console.log('here');
        el.classList.add('last');
    }
})

function resetSlideStyles(element) {
    element.style.removeProperty('height');
    element.style.removeProperty('overflow');
    element.style.removeProperty('transition');
    element.classList.remove('animating');
}

// Slide down function
export function slideDown(element, duration = 300) {
    clearAnimationTimer(element);

    if (isVisible(element)) {
        resetSlideStyles(element);
        return;
    }

    const animationDuration = Number(duration) || 300;

    element.style.removeProperty('display'); // Ensure the element can use its stylesheet display value.
    element.classList.add('animating');

    if (!isVisible(element)) {
        element.style.display = 'block';
    }

    const height = element.scrollHeight; // Get the full height

    element.style.height = '0'; // Start from height 0
    element.style.overflow = 'hidden'; // Hide overflowing content
    element.style.transition = `height ${animationDuration}ms ${slideEasing}`;
    element.offsetHeight;

    const frame = window.requestAnimationFrame(() => {
        element.style.height = height + 'px'; // Animate to full height
    });

    function finish(event) {
        if (event && event.target !== element) {
            return;
        }

        resetSlideStyles(element);
        element.removeEventListener('transitionend', finish);
        animationTimers.delete(element);
    }

    element.addEventListener('transitionend', finish);

    const fallback = window.setTimeout(finish, animationDuration + 50);
    animationTimers.set(element, {
        frame,
        timeouts: [fallback],
        cleanup: () => element.removeEventListener('transitionend', finish),
    });
}

// Slide up function
export function slideUp(element, duration = 300) {
    clearAnimationTimer(element);

    if (!isVisible(element)) {
        resetSlideStyles(element);
        return;
    }

    const animationDuration = Number(duration) || 300;

    element.classList.add('animating');
    const height = element.getBoundingClientRect().height || element.scrollHeight; // Get the current height

    element.style.height = height + 'px'; // Set the height to full
    element.style.overflow = 'hidden'; // Hide overflowing content
    element.style.transition = `height ${animationDuration}ms ${slideEasing}`;
    element.offsetHeight;

    const frame = window.requestAnimationFrame(() => {
        element.style.height = '0'; // Animate to height 0
    });

    function finish(event) {
        if (event && event.target !== element) {
            return;
        }

        element.style.display = 'none';
        resetSlideStyles(element);
        element.removeEventListener('transitionend', finish);
        animationTimers.delete(element);
    }

    element.addEventListener('transitionend', finish);

    const fallback = window.setTimeout(finish, animationDuration + 50);
    animationTimers.set(element, {
        frame,
        timeouts: [fallback],
        cleanup: () => element.removeEventListener('transitionend', finish),
    });
}

// Slide toggle function (combines slideUp and slideDown)
export function slideToggle(element, duration = 300) {
    if (window.getComputedStyle(element).display === 'none') {
        slideDown(element, duration);
    } else {
        slideUp(element, duration);
    }
}

export function isVisible(element) {
    return window.getComputedStyle(element).display !== 'none';
}

export function fadeIn(element, duration = 300) {
    clearAnimationTimer(element);

    element.style.opacity = '0';
    element.style.display = '';

    if (!isVisible(element)) {
        element.style.display = 'block';
    }

    element.style.transition = `opacity ${duration}ms`;
    element.offsetHeight;
    element.style.opacity = '1';

    const timer = window.setTimeout(() => {
        element.style.transition = '';
        animationTimers.delete(element);
    }, duration);

    animationTimers.set(element, timer);
}

export function fadeOut(element, duration = 300) {
    clearAnimationTimer(element);

    element.style.opacity = window.getComputedStyle(element).opacity;
    element.style.transition = `opacity ${duration}ms`;
    element.offsetHeight;
    element.style.opacity = '0';

    const timer = window.setTimeout(() => {
        element.style.display = 'none';
        element.style.transition = '';
        animationTimers.delete(element);
    }, duration);

    animationTimers.set(element, timer);
}

function clearAnimationTimer(element) {
    const timer = animationTimers.get(element);

    if (!timer) {
        return;
    }

    if (typeof timer === 'number') {
        window.clearTimeout(timer);
    } else {
        timer.timeouts?.forEach((timeout) => window.clearTimeout(timeout));

        if (timer.frame) {
            window.cancelAnimationFrame(timer.frame);
        }

        timer.cleanup?.();
    }

    animationTimers.delete(element);
}

function log(x) {
    console.log(x);
}
